import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';

// Sample data
// const data = {
//   forecastScheduleListForAuditUI: [
//     {
//       poNumber: 5100000676,
//       poDrugList: [
//         { drugName: "IMCL-986465", drugID: 1, collabrixForecastScheduleID: 92827262 },
//         { drugName: "IMCL-986466", drugID: 2, collabrixForecastScheduleID: 92827263 },
//         { drugName: "IMCL-986466", drugID: 2, collabrixForecastScheduleID: 92827266 },
//         { drugName: "IMCL-986467", drugID: 3, collabrixForecastScheduleID: 92827264 }
//       ]
//     },
//     {
//       poNumber: 5100000670,
//       poDrugList: [
//         { drugName: "IMCL-986369", drugID: 4, collabrixForecastScheduleID: 92827265 },
//         { drugName: "IMCL-986470", drugID: 5, collabrixForecastScheduleID: 92827266 },
//         { drugName: "IMCL-986471", drugID: 6, collabrixForecastScheduleID: 92827267 }
//       ]
//     }
//   ]
// };

const ForecastScheduleFilters = (props) => {
  const { data, handleSelectChange } = props;
  const [selectedPO, setSelectedPO] = useState(null);
  const [selectedDrug, setSelectedDrug] = useState(null);
  const [selectedForecastID, setSelectedForecastID] = useState(null);

  const poOptions = data ? data.filter(item => item.poDetails).map(item => item.poDetails) : [];

  const drugOptions = selectedPO
  ? Array.from(
      new Set(
        data
          .find(item => item.poDetails === selectedPO)
          .poDrugList.map(drug => drug.drugID)
      )
    )
  : [];

  const forecastOptions = selectedPO && selectedDrug
    ? data
        .find(item => item.poDetails === selectedPO)
      .poDrugList.filter(drug => drug.drugID === selectedDrug).length > 0 ? data
      .find(item => item.poDetails === selectedPO)
    .poDrugList.filter(drug => drug.drugID === selectedDrug)[0].collabrixForecastScheduleIDs : []
    : [];

  return (
    <Grid container spacing={2}>
      {/* PO Number Autocomplete */}
      <Grid item xs={12} sm={6} md={4}>
      <Autocomplete
          options={poOptions}
          name='forecastPONumber'
        getOptionLabel={(option) => option.toString()}
        onChange={(event, value) => {
          setSelectedPO(value);
          setSelectedDrug(null);  // Reset Drug when PO changes
          setSelectedForecastID(null);  // Reset Forecast when PO changes
          handleSelectChange('forecastPONumber',value)
        }}
        renderInput={(params) => <TextField {...params} label="Select PO Number" InputProps={{
          ...params.InputProps,
          startAdornment: <SearchIcon />,
        }} />}
      />
      </Grid>
      {/* Drug ID Autocomplete */}
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          name='forecastDrugId'
        options={drugOptions}
        getOptionLabel={(option) => option}
        value={selectedDrug}
        onChange={(event, value) => {
          setSelectedDrug(value);
          setSelectedForecastID(null);  // Reset Forecast when Drug changes
          handleSelectChange('forecastDrugId', value)
        }}
        renderInput={(params) => <TextField {...params} label="Select Drug ID" InputProps={{
          ...params.InputProps,
          startAdornment: <SearchIcon />,
        }} />}
        disabled={!selectedPO}  // Disable until PO is selected
      />
      </Grid>
      {/* Forecast Schedule ID Autocomplete */}
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id='forecastScheduleId'
        options={forecastOptions}
        getOptionLabel={(option) => option.toString()}
        value={selectedForecastID}
          onChange={(event, value) => {
            setSelectedForecastID(value);
            handleSelectChange('forecastScheduleId',value)
          }}
        renderInput={(params) => <TextField {...params} label="Select Forecast Schedule ID" InputProps={{
          ...params.InputProps,
          startAdornment: <SearchIcon />,
        }} />}
        disabled={!selectedDrug}  // Disable until Drug is selected
        />
        </Grid>
    </Grid>
  );
}

export default ForecastScheduleFilters;